function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

export const formatAvatarName = (name) => {
    if (!name) return;
    const numberPattern = /([a-z]*)([\d]*)/;
    let formatted = name.match(numberPattern);
    return `${capitalizeFirstLetter(formatted[1])} ${formatted[2]}`;
}